module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dash-body"
    }
  }, [_c('main', [_c('div', {
    staticClass: "clearfix section-body font-size-body",
    attrs: {
      "id": "index"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashBodyLoadingCondition(_vm.dashBodyLoading, _vm.$route.name)),
      expression: "dashBodyLoadingCondition(dashBodyLoading, $route.name)"
    }],
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "cssload-spinner"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "info-delete"
    }
  }), _vm._v(" "), _c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07079f94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dash/components/dashBody.vue
// module id = 576
// module chunks = 2